<template>
  <el-select
    ref="bank"
    v-model="selected"
    placeholder="Selecione  uma opção"
    @change="update()"
  >
    <el-option
      v-for="row of banks"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { BankService } from "@/services/customers/bank.services";
export default {
  name: "BankList",
  props: ["current"],
  data: function () {
    return {
      banks: [],
      selected: "",
    };
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    }
  },
  methods: {
    fetchRecords() {
      const vm = this;
      BankService.list()
        .then((response) => {
          vm.banks = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 300);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
};
</script>